"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.formatMessageDate = exports.toShortTimeString = exports.toLongDateString = exports.toDateString = exports.toDayOfWeekString = void 0;
const dateFunctions = __importStar(require("../utils/dateFunctions"));
function toDayOfWeekString(date) {
    return date.toLocaleDateString(undefined, { weekday: "long" });
}
exports.toDayOfWeekString = toDayOfWeekString;
function toDateString(date) {
    return date.toLocaleDateString();
}
exports.toDateString = toDateString;
function toLongDateString(date) {
    const weekday = date.toLocaleDateString("en", { weekday: "long" });
    const dayOfMonth = date.getDate();
    const month = date.toLocaleDateString(undefined, { month: "short" });
    const ordinal = getOrdinal(dayOfMonth);
    const year = date.getFullYear();
    return `${weekday} ${dayOfMonth}${ordinal} ${month} ${year}`;
}
exports.toLongDateString = toLongDateString;
function toShortTimeString(date) {
    return date.toLocaleTimeString(undefined, { hour: "2-digit", minute: "2-digit", hour12: false });
}
exports.toShortTimeString = toShortTimeString;
function formatMessageDate(date) {
    const startOfToday = dateFunctions.getStartOfToday();
    if (date >= startOfToday) {
        return toShortTimeString(date);
    }
    const startOfYesterday = dateFunctions.addDays(startOfToday, -1);
    if (date >= startOfYesterday) {
        return "Yesterday";
    }
    const useDayNameOnly = date >= dateFunctions.addDays(startOfToday, -6);
    return useDayNameOnly
        ? toDayOfWeekString(date)
        : toDateString(date);
}
exports.formatMessageDate = formatMessageDate;
function getOrdinal(n) {
    // TODO - Localise
    // Taken from https://stackoverflow.com/a/39466341
    return [, "st", "nd", "rd"][n / 10 % 10 ^ 1 && n % 10] || "th";
}
